import { Component, Vue } from 'vue-property-decorator'
import { formatDate } from '@/utils/timeFilter'
import {getMessageRemindById, getMessageReviewById, setMessageReviewUserByMessageReviewId} from '@/api/message'
import { setFinanceBackMoneyStatus } from '@/api/financial-center'
import * as math from 'mathjs'

@Component({})
export default class BackMoneyStudentInfo extends Vue {
    logShow = true
    backMoneyId = NaN
    backMoneyInfo: any = ''
    type = ''

    cancleReview = false
    reviewDialog = false
    opinion = '' // 审批意见
    status: number = null // 提交时候用到的状态
    reviewStatus: string = null //审批状态
    editFileList = []
    editFiles = {
        account: null,
        backMoneyAt: null,
        financeBackMoneyProofList: null
    }
    isRequired = false
    previewVisible = false
    previewPath = []
    types = ''

    get orderAllPrice() {
        let num = 0
        if (this.backMoneyInfo) this.backMoneyInfo.financeBackMoneyDetailList.forEach(item =>
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.price))))
        )
        return num
    }

    get needBackMoney() {
        let num = 0
        if(this.backMoneyInfo) this.backMoneyInfo.financeBackMoneyDetailList.forEach(item =>
            num = math.number(math.add(math.bignumber(num), math.bignumber(Number(item.needBackMoney))))
        )
        return num
    }

    get thisBackMoney() {
        let num = 0
        if(this.backMoneyInfo) this.backMoneyInfo.financeBackMoneyDetailList.forEach(item =>
            num = math.number(math.add(math.bignumber(num),math.bignumber(Number(item.thisTimePrice))))
        )
        return num
    }

    get elImageUrls() {
        return this.backMoneyInfo ? this.backMoneyInfo.financeBackMoneyProofList.map(item => item.url): []
    }


    created() {
        //  获取地址栏里的参数
        const url = window.location.href
        const p = url.split('?')[1]
        const params = new URLSearchParams(p)
        const recordId = params.get('id')
        this.types = this.$route.query.types ? this.$route.query.types as string : ''
        this.getMsgData(recordId)

    }

    formatDate = formatDate


    fileExtension(type) {
        return type.substring(type.lastIndexOf('.') + 1)
    }

    // 获取数据
    async getMsgData(id) {
        const data: any = await getMessageRemindById({id: id})
        this.backMoneyInfo = data.result.messageRemindInfo
        this.editFileList = this.backMoneyInfo.editFileList
        this.editFileList && this.editFileList.forEach(item => {
            this.editFiles[item.file] = this.backMoneyInfo[item.file]
        })
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填

    }
    async getFinanceBackMoneyById() {
        const data: any = await getMessageReviewById(this.backMoneyId,this.types)
        this.backMoneyInfo = data.result
        this.editFileList = this.backMoneyInfo.editFileList
        this.editFileList && this.editFileList.forEach(item => {
            this.editFiles[item.file] = this.backMoneyInfo[item.file]
        })
        if(this.editFileList && this.editFileList.length > 0) this.isRequired = this.type === '0' ? this.editFileList[0].isRequired === '1' ? true : false : false // 判断当前是查看还是审批，判断科比那集字段是否必填
    }

    // 验证当前字段是否可以编辑
    editFileShow(key: string) {
        if (this.reviewStatus !== '0' || this.type !== '0') return false
        if(this.editFileList != undefined && this.editFileList != null){
            return this.editFileList.some(item => item.file === key)
        }
    }

    uploadSuccess(res) {
        const { data } = res
        this.$message.success('上传成功')
        this.editFiles.financeBackMoneyProofList.push({ name: data.name, url: data.ossUrl })
    }
    uploadError() {
        this.$message.error('上传失败')
    }
    handleUploadRemove(file) {
        this.editFiles.financeBackMoneyProofList = this.editFiles.financeBackMoneyProofList.filter(item => item.uid !== file.uid)
    }

    handlePreview(file) {
        this.previewPath = [file.url]
        this.previewVisible = true
    }

    // 撤回审批
    async cancleReviewDialogConfirm() {
        await setFinanceBackMoneyStatus({ id: this.backMoneyInfo.id, action: '1' })
        this.$message.success('成功撤回审批')
        setTimeout(() => { window.close() }, 1500)
    }

    openReviewDialog(status: number) {
        this.status = status
        this.reviewDialog = true
    }

    // 关闭审批弹窗
    closeReviewDialog() {
        this.reviewDialog = false
        this.opinion = ''
    }

    reviewDialogConfirm() {
        const newObj = this.editFiles
        for(const key in newObj) {
            if(!this.editFileList.some(item => item.file === key)) {
                delete newObj[key]
            }
        }
        if(this.isRequired && this.status === 1) {
            for(const key in newObj) {
                if(!newObj[key] || newObj[key].length === 0) {
                    this.$message.error('请将编辑的信息填写完整')
                    break;
                }
            }
        }
        const obj = {
            messageReviewId: this.backMoneyId,
            status: this.status,
            opinion: this.opinion,
            form: this.status === 1 ? newObj : {},
        }
        setMessageReviewUserByMessageReviewId(obj).then(() => {
            this.$message.success(this.status === 1 ? '审批通过' : '审批驳回')
            setTimeout(() => {
                window.close()
            }, 1500)
        }).catch((err: Error) => {
            console.log(err)
        })
    }
}
